// Helper function to get bank account details from either new (array) or old (flat) structure
export const getBankAccountDetails = (entity, accountIndex = 0) => {
  if (!entity) {
    return { bankName: "", bankCode: "", accountNumber: "" }
  }

  // New structure: bankAccounts array
  if (entity.bankAccounts && Array.isArray(entity.bankAccounts)) {
    const account = entity.bankAccounts[accountIndex] || entity.bankAccounts[0]
    return {
      bankName: account?.bankName || "",
      bankCode: account?.bankCode || "",
      accountNumber: account?.accountNumber || "",
    }
  }

  // Old flat structure (backward compatibility)
  if (accountIndex === 0) {
    return {
      bankName: entity.bankName || "",
      bankCode: entity.bankCode || "",
      accountNumber: entity.accountNumber || "",
    }
  } else if (accountIndex === 1) {
    return {
      bankName: entity.bankName2 || "",
      bankCode: entity.bankCode2 || "",
      accountNumber: entity.accountNumber2 || "",
    }
  } else if (accountIndex === 2) {
    return {
      bankName: entity.bankName3 || "",
      bankCode: entity.bankCode3 || "",
      accountNumber: entity.accountNumber3 || "",
    }
  }

  return { bankName: "", bankCode: "", accountNumber: "" }
}

// Helper function to get available bank accounts for dropdown
export const getAvailableBankAccounts = (entity) => {
  if (!entity) {
    return []
  }

  // New structure: bankAccounts array
  if (entity.bankAccounts && Array.isArray(entity.bankAccounts)) {
    return entity.bankAccounts
      .map((account, index) => ({
        label: account.bankName || `Account ${index + 1}`,
        value: index,
      }))
      .filter((acc) => acc.label)
  }

  // Old flat structure (backward compatibility)
  const accounts = []
  if (entity.bankName) {
    accounts.push({ label: entity.bankName, value: 0 })
  }
  if (entity.bankName2) {
    accounts.push({ label: entity.bankName2, value: 1 })
  }
  if (entity.bankName3) {
    accounts.push({ label: entity.bankName3, value: 2 })
  }

  return accounts
}
